import { mergeClass } from "../../../utils";
import PreviewDG1 from "./PreviewDG1";
import {
  PreviewDonorLandscape,
  PreviewLandscape,
  PreviewLandscapeLarge,
} from "./PreviewLandscape";
import { PreviewPortrait } from "./PreviewPortrait";
import { IPreviewProps } from "./utils";

const PreviewList = {
  1: PreviewDG1,
  2: PreviewLandscape,
  3: PreviewLandscapeLarge,
  4: PreviewPortrait,
  501: PreviewLandscape,
  502: PreviewDonorLandscape,
  6: PreviewLandscapeLarge,
  7: PreviewLandscapeLarge,
  8: PreviewLandscapeLarge,
};

const ScreenTypeError = ({}: IPreviewProps) => (
  <div className="text-sm text-darkGrayBg border border-dashed w-fit px-4 py-2 my-4">
    Preview unavailable
  </div>
);

const PreviewSelector = ({
  screenType,
  itemData,
  forSlides = false,
}: {
  screenType: number;
  itemData: any;
  forSlides?: boolean;
}) => {
  const Preview =
    PreviewList[screenType as keyof typeof PreviewList] || ScreenTypeError;
  return (
    <>
      {!forSlides && <div className="font-medium mb-2 mt-5">Preview</div>}
      <Preview itemData={itemData} />
    </>
  );
};

export { PreviewSelector };
